import { Create, ListButton, TopToolbar } from 'react-admin';

import ChevronLeft from '@material-ui/icons/ChevronLeft';

import DocumentTypeForm from './DocumentTypeForm';

const DocumentTypeActions = ({ basePath }: any) => (
  <TopToolbar>
    <ListButton
      basePath={basePath}
      label='ra.action.back'
      icon={<ChevronLeft />}
    />
  </TopToolbar>
);

const DocumentTypeCreate = (props: any) => {
  return (
    <Create actions={<DocumentTypeActions {...props} />} {...props}>
      <DocumentTypeForm />
    </Create>
  );
};

export default DocumentTypeCreate;
